export const taskStatuses = Object.freeze({
  ACTIVE: 'active',
  COMPLETED: 'completed',
  PENDING: 'pending',
});

export const MIN_TOTAL_SUBTASKS_COUNT = 2;
